import { BaseRouteService } from 'core/services';

class CredentialsValidationRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'credentials-validation/';
	}

	validateChannel(resource) {
		return super.create(this.base + 'validate-channel', resource);
	}

	validateCarrier(resource) {
		return super.create(this.base + 'validate-carrier', resource);
	}
}
export default CredentialsValidationRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/CredentialsValidationRouteService.js